import { render, staticRenderFns } from "./location-settings.vue?vue&type=template&id=1ec479f9&"
import script from "./location-settings.vue?vue&type=script&lang=js&"
export * from "./location-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports